import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://apexdetailing.cz";
const DEFAULT_IMAGE = `${SITE_URL}/images/og-cover.jpg`;

/**
 * Per-page SEO tags (title, meta description, canonical, Open Graph).
 * Every route MUST render this with a UNIQUE title+description — duplicate
 * titles/descriptions across pages was flagged by the SEO audit as a ranking
 * blocker for "apex detailing prague".
 */
export default function SEO({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false }) {
  const fullTitle = title ? `${title} | Apex Detailing Praha` : "Apex Detailing Praha — Profesionální detailing vozů";
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="cs_CZ" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
